<template>
  <div class="w-full flex gap-2" vs-align="center" :class="!!widthClass ? widthClass : 'xl:w-auto'">
    <div v-if="!!label" class="title" :class="size">{{ label }}</div>
    <div class="flex-1" :class="size" >
      <vs-select class="w-full" autocomplete v-model="select" @change="change" :disabled="readonly">
        <vs-select-item v-for="(item, index) in list" :key="index" :text="item.text || item.value" :value="item.value" />
      </vs-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchNavItemSelect",
  props: {
    label: {
      type: String,
      default: "",
    },
    value: [Number, String],
    list: Array,
    size: {
      type: String,
      default: "normal",
    },
    readonly: Boolean,
    widthClass: String,
    name: {
      type: String,
      default: "searchType",
    },
    searchOnChange: {
      type: Boolean,
      default: false
    },
    notSet: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(value) {
      this.select = value;
    },
    list: {
      deep: true,
      immediate: true,
      handler() {
        if (this.notSet) return;

        if (!this.value) {
          if (Array.isArray(this.list) && this.list.length > 0) {
            this.select = this.list[0].value;
            this.$nextTick(() => {
              this.change(this.select);
            });
          }
          if (typeof this.list === "number") {
            //this.select = this.list
          }
        }
      },
    },
  },
  computed: {
    getSearchType () {
      const query = this.$route.query;
      if (query[this.name]) {
        try {
          return query[this.name]
        } catch (e) {}
      }
      return this.select
    },
  },
  data() {
    return {
      select: this.value,
      lastChangeTime: 0
    };
  },
  created() {
    this.select = this.getSearchType;
    if (!this.notSet) {
      this.$nextTick(() => {
        this.change(this.select);
      });
    }
  },
  methods: {
    change(data) {
      // 이벤트 중복 호출 방지
      const now = Date.now();
      if (now - this.lastChangeTime < 200) {
        return;
      }
      this.lastChangeTime = now;

      this.$emit("input", data);
      this.$emit("change", data);

      if (this.searchOnChange) {
        this.$nextTick(() => {
          this.$emit("search");
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div.small {
  width: 114px;
}

.title {
  font-weight: 500;
  line-height: 38px;
  text-align: left;
  white-space: nowrap;

  &.small {
    width: auto !important;
  }
}

@media (max-width: 1200px) {
  .title {
    width: 80px !important;
  }
}
</style>
